// Package imports:
import React, { useContext, useEffect, useState } from "react";
// Component imports:
import Button from '../../ui-elements/Button/Button';
import Tabs from '../../ui-elements/Tabs/Tabs';
import GemmaqContainer from './GemmaqContainer/GemmaqContainer';
import HeadSection from "../../ui-elements/HeadSection/HeadSection";
// Type imports:
import { IDefaultProps } from '../../types/Types';
// Context imports:
import { AccessTokenContext } from '../../contexts/AccessTokenContext';

const Gemmaq: React.FC = () => {
    const accessToken = useContext(AccessTokenContext);
    const [defaultProps, setDefaultProps] = useState<IDefaultProps>({
        accessToken,
        refreshRateMs: 60 * 60 * 1000
    });

    useEffect(() => {
        setDefaultProps({
            ...defaultProps,
            accessToken
        });
    }, [accessToken]);

    return (
        <div className="main KCL_gemmaq-page">
            <div className="main__inner-fluid">
                    <div className="container">
                        <HeadSection
                            title='GEMMAQ kynjakvarði'
                            description={
                                <>
                                    <p>GEMMAQ kynjakvarðinn veitir upplýsingar um kynjahlutföll í leiðtogastörfum fyrirtækja á íslenskum markaði, skráð og óskráð, eins og staðan er hverju sinni.</p>
                                    <p className="smaller">Einkunnir eru gefnar á skalanum 0-10, þar sem 10 er hæsta einkunnin, miðað við hlutfall kvenna í framkvæmdastjórn og stjórn félagsins. Kvarðinn tekur til greina bæði kyn forstjóra og stjórnarformanns - sem reiknast jafnframt inn í GEMMAQ einkunn félags þegar kona gegnir stöðunni.</p>
                                </>
                            }
                            actions={
                                <>
                                    <Button
                                        size='lg'
                                        buttonType='secondary'
                                        anchorProps={{ href: 'https://www.gemmaq.io/', target: '_blank' }}
                                    >
                                        Vefur GEMMAQ Ratings
                                    </Button>
                                    <Button
                                        size='lg'
                                        buttonType='primary'
                                        anchorProps={{ href: '/Markadir/Gemmaq-Pontun' }}
                                    >
                                        GEMMAQ notkunarleyfi
                                    </Button>  
                                </>
                            }
                            rightSide={
                                <>
                                    <p className="percentile">Prósentuhlutfall kvenna í stjórn og framkvæmdastjórn</p>
                                    <div className="bottomRightBox">
                                        <div className="color">
                                            <div className="colorStick" id="A" />
                                            <div className="colorStick" id="B" />
                                            <div className="colorStick" id="C" />
                                            <div className="colorStick" id="D" />
                                            <div className="colorStick" id="E" />
                                            <div className="colorStick" id="F" />
                                        </div>

                                        <div className="percentages">
                                            <p>50% +</p>
                                            <p>40-49%</p>
                                            <p>30-39%</p>
                                            <p>20-29%</p>
                                            <p>10-19%</p>
                                            <p>0-9%</p>
                                        </div>

                                        <p className="glColorsInfo">Bjartari litir í kynjakvarðanum sýna að meira jafnvægi sé milli kynjanna við stjórn. </p>
                                    </div>
                                </>
                            }
                        />
                    </div>

                    <div className="section__body">
                        <Tabs 
                            tabs={[{
                                id: "a-o",
                                label: "A-Ö",
                                component: <GemmaqContainer
                                    {...defaultProps}
                                    category='all'
                                />
                            }, {
                                id: "Útgefendur-skuldabréfa",
                                label: "Útgefendur skuldabréfa",
                                component: <GemmaqContainer
                                    {...defaultProps}
                                    category='XICE-BOND-ISSUERS'
                                />
                            }, {
                                id: "Skráð -hlutabréf",
                                label: "Skráð hlutabréf",
                                component: <GemmaqContainer
                                    {...defaultProps}
                                    category='XICE'
                                />
                            }, {
                                id: "Óskráð-félög",
                                label: "Óskráð félög",
                                component: <>
                                    <div className="publishing-message">
                                        <h4>Viltu að þitt fyrirtæki birtist á þessum lista?</h4>
                                        <Button
                                            size='lg'
                                            buttonType='primary'
                                            anchorProps={{ href: '/Markadir/Gemmaq-Birting' }}
                                        >
                                            Panta birtingu
                                        </Button>
                                    </div>
                                    <GemmaqContainer
                                        {...defaultProps}
                                        category='OTC'
                                    />
                                </>
                            }, {
                                id: "Topp-10",
                                label: "Topp 10",
                                component: <GemmaqContainer
                                    {...defaultProps}
                                    category='top10'
                                />
                            }, {
                                id: "Neðstu-10",
                                label: "Neðstu 10",
                                component: <GemmaqContainer
                                    {...defaultProps}
                                    category='bottom10'
                                />
                            }]}
                            tabsSize='lg'
                            grayAndShell
                        />
                    </div>
            </div>
        </div>
    )
}

export default Gemmaq;